module.exports = __webpack_public_path__ + "static/media/Resume.c05a0748.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Resume.pdf
// module id = 26
// module chunks = 1